import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import DeliveryOrderActions from "../../../../reducers/modules/sales/delivery-order/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "sales/delivery-order";

export default class DeliveryOrderMiddleware {
  static create() {
    return (dispatch) => {
      dispatch(DeliveryOrderActions.create());
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(DeliveryOrderActions.update());
      DeliveryOrderMiddleware.showOne(dispatch, params);
    };
  }

  static list(params) {
    return (dispatch) => {
      dispatch(DeliveryOrderActions.process());
      DeliveryOrderMiddleware.showlist(dispatch, params);
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(DeliveryOrderActions.reset());
    };
  }
  static resetList() {
    return (dispatch) => {
      dispatch(DeliveryOrderActions.resetList());
    };
  }
  static getOne(params) {
    return (dispatch) => {
      dispatch(DeliveryOrderActions.view());
      DeliveryOrderMiddleware.showOne(dispatch, params);
    };
  }

  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(DeliveryOrderActions.submit());
      DeliveryOrderMiddleware.saveNew(dispatch, post, search);
    };
  }
  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(DeliveryOrderActions.submit());
      DeliveryOrderMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }

  static getPrint(params) {
    return (dispatch) => {
      dispatch(DeliveryOrderActions.beforePrint());
      DeliveryOrderMiddleware.showPrint(dispatch, params);
    };
  }

  static beforeDelete(id, params) {
    return (dispatch) => {
      dispatch(DeliveryOrderActions.delete());
      DeliveryOrderMiddleware.delete(dispatch, params, id);
    };
  }

  static getHelper(params = null) {
    return (dispatch) => {
      DeliveryOrderMiddleware.showHelper(dispatch, params);
    };
  }

  static getHelperFull(params = null) {
    return (dispatch) => {
      DeliveryOrderMiddleware.showHelperFull(dispatch, params);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static showHelperFull(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${DeliveryOrderMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-delivery-order-helper",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(DeliveryOrderActions.helperFull(response.data.result));
        }
      })
      .catch((error) => {
        DeliveryOrderMiddleware.alertHendler(dispatch, error);
      });
  }
  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${DeliveryOrderMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(DeliveryOrderActions.list(response.data.result));
        }
      })
      .catch((error) => {
        DeliveryOrderMiddleware.alertHendler(dispatch, error);
      });
  }
  static showHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${DeliveryOrderMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-sales-order",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(DeliveryOrderActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        DeliveryOrderMiddleware.alertHendler(dispatch, error);
      });
  }
  static showPrint(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${DeliveryOrderMiddleware.getToken()}`,
      },
      url: url + "/print/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(DeliveryOrderActions.print(response.data.result));
        }
      })
      .catch((error) => {
        DeliveryOrderMiddleware.alertHendler(dispatch, error);
      });
  }

  static showOne(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${DeliveryOrderMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(DeliveryOrderActions.view(response.data.result));
        }
      })
      .catch((error) => {
        DeliveryOrderMiddleware.alertHendler(dispatch, error);
      });
  }

  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${DeliveryOrderMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            DeliveryOrderActions.process(),
            DeliveryOrderMiddleware.showlist(dispatch, params)
          );
          DeliveryOrderMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Cancel Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        DeliveryOrderMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${DeliveryOrderMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            DeliveryOrderActions.process(),
            DeliveryOrderMiddleware.showlist(dispatch, search)
          );
          dispatch(DeliveryOrderActions.success());
          DeliveryOrderMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Create Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        DeliveryOrderMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${DeliveryOrderMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            DeliveryOrderActions.process(),
            DeliveryOrderMiddleware.showlist(dispatch, search)
          );
          dispatch(DeliveryOrderActions.success());
          DeliveryOrderMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        DeliveryOrderMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(DeliveryOrderActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(DeliveryOrderActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
